export default require('./TimerDuration').default
